import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
//import { authGuard } from "@auth0/auth0-vue";
import HomeView from '../views/HomeView.vue'
import vuetify from '../plugins/vuetify'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Übersicht',
    component: HomeView,
  },
  {
    path: '/register',
    name: 'Registrierung',
    component: () => import('../views_out/RegisterView.vue'),
    //beforeEnter: checkbefore,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views_out/LoginView.vue'),
    //beforeEnter: checkbefore,
  },
  {
    path: '/confirm',
    name: 'Bestätigen',
    component: () => import('../views_out/ConfirmationView.vue'),
    //beforeEnter: checkbefore,
  },
  {
    path: '/persona',
    name: 'Persona',
    component: () => import('../views/bottomsub/PersonaView.vue'),
    //beforeEnter: checkbefore,
  },
  {
    path: '/report',
    name: 'Bericht',
    component: () => import('../views/bottomsub/ReportView.vue'),
    //beforeEnter: checkbefore,
  },  
  {
    path: '/calendar',
    name: 'Kalender',
    component: () => import('../views/CalendarView.vue'),
    //beforeEnter: authGuard,
  },
  {
    path: '/settings',
    name: 'Einstellungen',
    component: () => import('../views/SettingsView.vue'),
    //beforeEnter: authGuard,
  },
  {
    path: '/analyze',
    name: 'Analyse',
    component: () => import('../views/bottomsub/AnalyzeView.vue'),
    //beforeEnter: authGuard,
  },
  {
    path: '/lifeview',
    name: 'Lebensansicht',
    component: () => import('../views/bottomsub/LifeviewView.vue'),
    //beforeEnter: authGuard,
  },
  {
    path: '/cyleview',
    name: 'Zyklusansicht',
    component: () => import('../views/bottomsub/CycleView.vue'),
    //beforeEnter: authGuard,
  },
  {
    path: '/knowledge',
    name: 'Informiere Dich',
    component: () => import('../views/KnowledgeView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/settingsMainComponent',
    name: 'Settings',
    component: () => import('../views/settingparts/settingMenu/SettingMainComponent.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/profile',
    name: 'Profil',
    component: () => import('../views/settingparts/ProfileView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/import',
    name: 'Datenimport',
    component: () => import('../views/settingparts/ImportView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/dataoverview',
    name: 'Datenübersicht',
    component: () => import('../views/settingparts/DataoverviewView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/datawallet',
    name: 'Data Wallet',
    component: () => import('../views/settingparts/DatawalletView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/credentials',
    name: 'Zugangsdaten',
    component: () => import('../views/settingparts/CredentialsView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/datadonation',
    name: 'Datenspende',
    component: () => import('../views/settingparts/DatadonationView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/dataprivacy',
    name: 'Datenschutz',
    component: () => import('../views/settingparts/DataprivacyView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/deletedata',
    name: 'Datenlöschen',
    component: () => import('../views/settingparts/DeleteData.vue'),
    //beforeEnter: authGuard,
  },
  {
    path: '/overapp',
    name: 'Über diese App',
    component: () => import('../views/settingparts/OverappView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/databackup',
    name: 'Datenbackup',
    component: () => import('../views/settingparts/Databackupiew.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/period',
    name: 'Periode',
    component: () => import('../views/input/PeriodView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/periodday',
    name: 'Periodentag',
    component: () => import('../views/input/PeriodDay.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/mood',
    name: 'Stimmung',
    component: () => import('../views/input/MoodView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/notes',
    name: 'Notizen',
    component: () => import('../views/input/NotesView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: '/symptoms',
    name: 'Symptome',
    component: () => import('../views/input/SymptomsView.vue'),
    //beforeEnter: authGuard,

  },
  {
    path: "/:catchAll(.*)",
    name: "Not Found",
    component: () => import('../views/NotFoundView.vue'),
  },
]

function checkbefore(){
  //console.log(authGuard);
}

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
